import './zama/style';
import FormStructure from './zama/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/includes.js